'use client';

import webStorageKeys from '@/constants/web-storage-keys';
import { uiService } from '@/services/ui.service';
import { useTranslations } from 'next-intl';
import { useEffect, useRef, useState } from 'react';

interface TutorialTooltipProps {
	className: string;
}
export const TutorialTooltip = ({ className }: TutorialTooltipProps) => {
	const [isShow, setIsShow] = useState<boolean>(false);
	const t = useTranslations('General');
	const timerRef = useRef<ReturnType<typeof setTimeout>>();
	useEffect(() => {
		const showTip = () => {
			clearTimeout(timerRef.current);
			setIsShow(true);
			timerRef.current = setTimeout(() => {
				setIsShow(false)
			}, 3000)
		}
		const hasShowTutorial = Boolean(localStorage.getItem(webStorageKeys.HAS_SHOWN_NEWBIE_TUTORIAL_INFO) || false);
		if (hasShowTutorial) {
			showTip();
		}
		const subscription = uiService.onDisplayTutorialToolTip$.subscribe(() => showTip());
		return () => {
			timerRef.current && clearTimeout(timerRef.current);
			subscription.unsubscribe();
		}
	}, [])

	return (
		<div
			className={className}
			data-active={isShow ? true : undefined}
		>
			{ t('lbl_MarsNBetGuide') }
		</div>
	);
}